export default {"src":"/_next/static/media/financial-plan.1c96e7de.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};